import { render, staticRenderFns } from "./withdrawAccount.vue?vue&type=template&id=b7145b30&scoped=true"
import script from "./withdrawAccount.vue?vue&type=script&lang=js"
export * from "./withdrawAccount.vue?vue&type=script&lang=js"
import style0 from "./withdrawAccount.vue?vue&type=style&index=0&id=b7145b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7145b30",
  null
  
)

export default component.exports